// รับจ่าย S1 — kept free of imports so the sidebar and the router can read the path without
// pulling the page's helpers in.

export const INCOME_EXPENSE_REPORT_PATH = "/report/income-expense";

export const INCOME_EXPENSE_MENU_TITLE = "รับจ่าย";

/** The server's INCOME_EXPENSE_REPORT_MAX_DAYS, both ends included. */
export const REPORT_MAX_DAYS = 31;

/**
 * Head office's filter fires one all-branch query per change (the Pivot pool exhaustion of
 * 21 Oct), so a burst of picks settles before it is sent.
 */
export const FILTER_DEBOUNCE_MS = 400;

/** A day row's sparkline: its profit and the days before it, at most this many. */
export const DAY_TREND_LENGTH = 7;

/** The threshold settings (ตั้งค่าระบบ › รายงาน) the colours and the legend read. */
export const THRESHOLD_SETTING_KEY = {
  wasteGoodMax: "report.income_expense.waste_good_max_percent",
  wasteWarnMax: "report.income_expense.waste_warn_max_percent",
  expenseGoodMax: "report.income_expense.expense_good_max_percent",
  expenseWarnMax: "report.income_expense.expense_warn_max_percent",
  profitGoodMin: "report.income_expense.profit_good_min_percent",
  profitWarnMin: "report.income_expense.profit_warn_min_percent",
  fuelGoodBelow: "report.income_expense.fuel_good_below_percent",
  fuelWarnMax: "report.income_expense.fuel_warn_max_percent",
  billsWatchMin: "report.income_expense.bills_good_min",
} as const;

export const ESTIMATE_BADGE_TEXT = "ประมาณการ";
export const ACTUAL_BADGE_TEXT = "จริง";
export const NOT_APPROVED_BADGE_TEXT = "ยังไม่อนุมัติ";
export const ALL_BRANCHES_TEXT = "ทุกสาขา";
export const MISSING_DOCUMENT_TEXT = "มีวันที่ยังไม่มีเอกสารรายวันที่อนุมัติ";
export const RANGE_TOO_LONG_TEXT = `เลือกช่วงวันที่ได้ไม่เกิน ${REPORT_MAX_DAYS} วัน`;
